import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';

// routers
import Login from './login';
import Account from './account';
import Company from './company';
import Station from './station';
import SystemConfig from './systemConfig';
import Warehouse from './warehouse';
import Fridge from './fridge';
import Box from './box';
import BoxType from './boxType';
import IceBox from './iceBox';
import IceBoxType from './iceBoxType';
import IceBoxShelf from './iceBoxShelf';
import IceBoxPallet from './iceBoxPallet';
import Device from './device';
import Alarm from './alarm';
import AlarmExecutor from './alarmExecutor';
import Location from './location';
import IceBoxProcess from './iceBoxProcess';
import TransportOrder from './transportOrder';
import Transport from './transport';
import Group from './group';
import DeviceParam from './deviceParam';
import DeviceEvent from './deviceEvent';
import Asset from './asset';
import Log from './log';
import SmsSendLog from './smsSendLog';
import ExportData from './exportData';
import Car from './car';
import ColdStore from './coldStore';
import Shelter from './shelter';
import VoiceSendLog from './voiceSendLog';
import DeviceMonitor from './deviceMonitor';
import Fence from './fence';

// view
const Layout = () => import('Components/v-layout');
const NotFoundError = () => import('Views/not-found-error');

Vue.use(Router);

const Routes = [
  ...Login,
  ...DeviceMonitor,
  {
    path: '/',
    component: Layout,
    children: [
      ...Account,
      ...Company,
      ...Station,
      ...SystemConfig,
      ...Warehouse,
      ...Fridge,
      ...Box,
      ...BoxType,
      ...IceBox,
      ...IceBoxType,
      ...IceBoxShelf,
      ...IceBoxPallet,
      ...Device,
      ...Alarm,
      ...AlarmExecutor,
      ...Location,
      ...IceBoxProcess,
      ...TransportOrder,
      ...Transport,
      ...Group,
      ...DeviceParam,
      ...DeviceEvent,
      ...Asset,
      ...Log,
      ...SmsSendLog,
      ...ExportData,
      ...Car,
      ...ColdStore,
      ...Shelter,
      ...VoiceSendLog,
      ...Fence,
      { path: '*', name: 'NotFoundError', component: NotFoundError },
    ],
  },
];

const router = new Router({
  mode: 'history',
  routes: Routes,
});

router.beforeEach((to, from, next) => {
  store.dispatch('currentMenu', to.path);
  next();
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js